import { useEffect, useState } from 'react'

type ConfirmState = 'none' | 'needsConfirmation' | 'confirmed'

interface UseConfirmStateType {
  confirmState: ConfirmState
  overBudgetThreshold: boolean
  setConfirmState: (state: ConfirmState) => void
}

const UPPER_THRESHOLD = 1.1
const LOWER_THRESHOLD = 0.9

export const useConfirmState = (startingValue: number | undefined, currentValue: number | undefined): UseConfirmStateType => {
  const [confirmState, setConfirmState] = useState<ConfirmState>('none')
  const [overBudgetThreshold, setOverBudgetThreshold] = useState<boolean>(false)

  useEffect(() => {
    if (startingValue != null && currentValue != null) {
      const isUnderBudget = currentValue < startingValue * LOWER_THRESHOLD
      const isOverBudget = currentValue > startingValue * UPPER_THRESHOLD
      setOverBudgetThreshold(isOverBudget || isUnderBudget)
    }
  }, [currentValue, startingValue])

  return { confirmState, setConfirmState, overBudgetThreshold }
}
